import { Fragment } from "react/jsx-runtime";
import HeroSection from "../components/common/HeroSection";
import data from "../services.json";
import FAQ from "../components/Services/FAQSection";
import WhatweOffer from "../components/Services/WhatWeOffer";
import CTASection from "../components/common/CTASection";
import ClinicBanner from "../components/Services/ClinicBanner";
import DigitalHealthFAB from "../components/Digitalhealth";
import LifeStages from "../components/Services/LifeStages";
import { useEffect, useState } from "react";
import ConditionsGrid from "../components/Conditions/ConditionsCard";

const { services } = data;

const Services = () => {
  const heroSlides = [services.hero];
  const [apiServices, setApiServices] = useState([])
  const [loading, setLoading] = useState(true);
  const orgId = "6a3ba96dc8e05c65af7f0ef0";

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await fetch(
          `https://api.avexa.net/clinic-onboarding/clinics/${orgId}/services`
        );
        if (!res.ok) throw new Error("Failed to fetch services");
        const result = await res.json();
        setApiServices(result.filter((s) => s.status !== "INACTIVE"));
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);
  return (
    <Fragment>
      <DigitalHealthFAB />
      <HeroSection slides={heroSlides} />
      <WhatweOffer  services={apiServices} loading={loading} />
      {/* <LifeStages services={apiServices} loading={loading} /> */}
      <div >
      <ConditionsGrid/>
      </div>

      <ClinicBanner data={data.clinicBanner} />
      <FAQ />
      <CTASection data={data.callToAction} />
    </Fragment>
  );
};

export default Services;